import parser from 'ua-parser-js';

const platform = 'web';

const client = parser();

const clientInfo = {
  Browser: client.browser.name,
  'Browser Version': client.browser.version,
  'Operating System': client.os.name,
  'Operating System Version': client.os.version,
  'Screen Width': screen.width,
  'Screen Height': screen.height,
  'Current URL': document.URL,
  Referrer: document.referrer,
  application: 'admin',
};

const getAnalyticsHeaders = () => ({
  'analytics-client-info': JSON.stringify({
    platform,
    ...clientInfo,
  }),
});

export default getAnalyticsHeaders;
